import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL || "";

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) =>
                e && typeof e.msg === "string"
                    ? `${(e.loc || []).slice(-1)[0] || ""}: ${e.msg}`.trim()
                    : JSON.stringify(e),
            )
            .join(" · ");
    if (typeof detail.msg === "string") return detail.msg;
    // Iter60.p2 polish — backend returns structured detail objects like
    // `{code, message, module_id, role}` for pairing violations. Extract
    // the human-readable field instead of falling back to `String(obj)`
    // which renders as "[object Object]".
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.error === "string") return detail.error;
    if (typeof detail.reason === "string") return detail.reason;
    try { return JSON.stringify(detail); } catch { return "Request failed"; }
}

export function assetUrl(pathLike) {
    if (!pathLike) return "";
    if (pathLike.startsWith("http")) return pathLike;
    return `${ASSET_BASE}${pathLike}`;
}

export async function uploadFile(endpoint, file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await axios.post(`${API_BASE}${endpoint}`, fd, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}
